import React from 'react';

export const ClSerpSummary = ({
    priceTo,
    priceFrom,
    count
}: {
    priceTo?: string;
    priceFrom?: string;
    count?: number;
}) => {
    return (
        <div style={{ display: 'none' }} itemProp='offers' itemScope itemType='http://schema.org/AggregateOffer'>
            <meta itemProp='offerCount' content={count?.toString()} />
            <meta itemProp='lowPrice' content={priceFrom} />
            <meta itemProp='highPrice' content={priceTo} />
            <meta itemProp='priceCurrency' content='RUB' />
        </div>
    );
};
